import { render } from "./BingChatBotSettings.vue?vue&type=template&id=4509bce3"
import script from "./BingChatBotSettings.vue?vue&type=script&lang=js"
export * from "./BingChatBotSettings.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__